import styled from "styled-components";

export const StyledDataSummary = styled.div`
  color: #2f2f2f;
  font-family: Public Sans;
`;

export const Label = styled.div`
  font-weight: 800;
  font-size: 14px;
  margin-bottom: 8px;
`;

export const Data = styled.div`
  font-size: 16px;
  line-height: 19px;
`;
